// extracted by mini-css-extract-plugin
module.exports = {"root":"ElapsedTime_root__1QOO_"};